import { EvaluationCriteriaService } from 'data/services';
import { EvaluationCriteriaServiceInterface } from 'domain/services';
import { makeRemoteCloneEvaluationCriteria } from 'main/factories/usecases/evaluation-criteria/clone-evaluation-criteria-factory';
import { makeRemoteCreateEvaluationCriteria } from 'main/factories/usecases/evaluation-criteria/create-evaluation-criteria-factory';
import { makeRemoteDeleteEvaluationCriteria } from 'main/factories/usecases/evaluation-criteria/delete-evaluation-criteria-factory';
import { makeRemoteGetAllEvaluationCriteria } from 'main/factories/usecases/evaluation-criteria/get-all-evaluation-criteria-factory';
import { makeRemoteGetEvaluationCriteriaById } from 'main/factories/usecases/evaluation-criteria/get-evaluation-criteria-by-id-factory';
import { makeRemoteUpdateEvaluationCriteria } from 'main/factories/usecases/evaluation-criteria/update-evaluation-criteria-factory';

export const makeEvaluationCriteriaService =
  (): EvaluationCriteriaServiceInterface => {
    return new EvaluationCriteriaService({
      cloneEvaluationCriteria: makeRemoteCloneEvaluationCriteria(),
      getAllEvaluationCriteria: makeRemoteGetAllEvaluationCriteria(),
      createEvaluationCriteria: makeRemoteCreateEvaluationCriteria(),
      updateEvaluationCriteria: makeRemoteUpdateEvaluationCriteria(),
      deleteEvaluationCriteria: makeRemoteDeleteEvaluationCriteria(),
      getEvaluationCriteriaById: makeRemoteGetEvaluationCriteriaById(),
    });
  };
